export const LOCK_ANALYTICS = 'appInfo/LOCK_ANALYTICS';
export const CLEAR_LOCK_ANALYTICS = 'appInfo/CLEAR_LOCK_ANALYTICS';
export const LOCK_DOMAINS = 'appInfo/LOCK_DOMAINS';
export const CLEAR_LOCK_DOMAINS = 'appInfo/CLEAR_LOCK_DOMAINS';

const appInfoReducer = (state = { ...window.appInfo }, action) => {
  switch (action.type) {
    case LOCK_ANALYTICS:
      return {
        ...state,
        lockedAnalyticIntegration: action.payload,
      };
    case CLEAR_LOCK_ANALYTICS:
      return {
        ...state,
        lockedAnalyticIntegration: undefined,
      };
    case LOCK_DOMAINS:
      return {
        ...state,
        lockedDomain: action.payload,
      };
    case CLEAR_LOCK_DOMAINS:
      return {
        ...state,
        lockedDomain: undefined,
      };
    default:
      return state;
  }
};

export const clearAnalytics = () => dispatch => {
  dispatch({ type: CLEAR_LOCK_ANALYTICS });
};

export const clearDomains = () => dispatch => {
  dispatch({ type: CLEAR_LOCK_DOMAINS });
};

export const lockAnalytics = analytic => dispatch => {
  dispatch({
    type: LOCK_ANALYTICS,
    payload: analytic,
  });
};

export const lockDomains = domain => dispatch => {
  dispatch({
    type: LOCK_DOMAINS,
    payload: domain,
  });
};

export default appInfoReducer;
